import axios from "axios";
import React, { useContext, useEffect, useState } from "react";
import Cookies from "js-cookie";
import { FetchDataTypes } from "../api/api";
import { Pie, Doughnut } from "react-chartjs-2";
import { Chart, ArcElement, Legend, Tooltip } from "chart.js";
Chart.register(ArcElement, Legend, Tooltip);

interface SAProps {
  title: string;
}

function AssetAllocationChart({ title }: { title: string }) {
  const [sectorAllocation, setSectorAllocation] = useState<any>(null);
  const selectedClient:any = Cookies.get("client")
  useEffect(() => {
    FetchDataTypes("AssetAllocation", parseInt(selectedClient),Cookies.get("newJwt"))
      .then((response) => response.json())
      .then((response) => {
        setSectorAllocation(response);
      });
  }, []);
console.log(sectorAllocation?.map((e: any) => {
  return e.assetPct;
}),)
  const data = {
    labels:
      sectorAllocation &&
      sectorAllocation.map((e: any) => {
        return e.assetType;
      }),
    datasets: [
      {
        label: "# of Votes",
        data:
          sectorAllocation &&
          sectorAllocation.map((e: any) => {
            return e.assetPct;
          }),
        backgroundColor: [
          
          
          "rgb(155,32,24)",
          
          "rgb(174,65,56)",
         
          
          "rgb(179,191,209)",
          "rgb(222,135,120)",
          "rgb(165,163,168)",
          
          
          
          
         
          
          // "rgba(255, 159, 64, 0.2)",
        ],
        borderWidth: 1,
      },
    ],
  };
  return (
    <div className="card w-100">
      <div className="card-header">
        <h5 className="card-title">{title}</h5>
      </div>
      <div className="card-body">
        <div className="chart chart-xs">
          <div className="chartjs-size-monitor">
            <div className="chartjs-size-monitor-shrink">
              <div className="">
                <Doughnut
                  data={data}
                  options={{
                    elements: {
                      point: {
                        radius: 1,
                      },
                    },
                    cutout: 135,
                    plugins: {
                      legend: {
                        position: "bottom",
                        labels: {
                          usePointStyle: true, //for style circle
                        },
                      },
                    },
                  }}
                />
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}

export { AssetAllocationChart };
